import service from '@/store/services/workshop/pool-service';

const state = {
  list: {},
  pool: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, pool) => {
    state.pool = pool;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((pool) => { commit('SET_RESOURCE', pool); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((pool) => { commit('SET_RESOURCE', pool); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((pool) => { commit('SET_RESOURCE', pool); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  pool: state => state.pool,
  page: state => state.meta.page,

};
 
const pool = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default pool;
